import { Link } from "react-router-dom";
import { ArrowRight, MapPinOff, Phone } from "lucide-react";
import { CONTACT } from "@/lib/data";

const CityNotListedCTA = () => (
  <section
    className="py-16 lg:py-20 bg-gradient-to-br from-ink via-[#0F2C4F] to-[#163A66] relative overflow-hidden"
    data-testid="city-not-listed-cta"
  >
    {/* Decorative grain */}
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.06] pointer-events-none"
      style={{
        backgroundImage:
          "radial-gradient(circle at 25% 30%, #C58A3F 0%, transparent 45%), radial-gradient(circle at 75% 70%, #C58A3F 0%, transparent 45%)",
      }}
    />

    <div className="container-tm relative">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/15 text-gold mb-6">
          <MapPinOff size={22} strokeWidth={1.6} />
        </span>
        <p className="overline text-gold mb-4">Votre commune n'est pas listée ?</p>
        <h2 className="font-serif font-light text-cream text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
          Nos équipes étudient
          <br />
          <em className="text-gold">tous les projets en Bretagne.</em>
        </h2>
        <p className="mt-6 font-sans text-cream/70 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          Si votre bien se trouve à 30-40 km de Saint-Malo, Dinan, Saint-Cast,
          Damgan ou La Roche-Bernard, nous pouvons probablement intervenir.
          Contactez-nous pour un retour sous 24h.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/contact"
            data-testid="city-cta-contact"
            className="inline-flex items-center justify-center gap-2 bg-gold text-ink font-semibold px-7 py-3.5 rounded-full hover:bg-cream transition-colors duration-300 text-sm"
          >
            Nous contacter <ArrowRight size={15} />
          </Link>
          <a
            href={CONTACT.phoneHref}
            data-testid="city-cta-phone"
            className="inline-flex items-center justify-center gap-2 border border-cream/30 text-cream px-7 py-3.5 rounded-full hover:bg-cream/10 transition-colors duration-300 text-sm"
          >
            <Phone size={14} strokeWidth={2} />
            {CONTACT.phone}
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default CityNotListedCTA;
